import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'


export function RemovePermissionPopup(props) {

  const [show, setShow] = useState(props.show);

  const handleClose = () => {
    setShow(false);
  };

  const handleClosed = () => {
    props.onCloseRemovePopup()
  };

  const account = props.account;



  return (
    <div>

      <Modal show={show} onHide={handleClose} onExited={handleClosed} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Rimuovi permesso</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Vuoi rimuovere questo ruolo dal permesso?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Annulla</Button>
          <Button variant="primary" onClick={handleClose}>Confermi</Button>
        </Modal.Footer>

      </Modal>

    </div>
  );

}

export default RemovePermissionPopup;

